<template>
  <div id="enterprise-invites-wizard">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      ref="formWizard"
      class="flex flex-row"
      :hideButtons="true"
      :startIndex="wizardStartIndex"
      :shape="wizardStepShape"
    >
      <tab-content
        v-for="(content, _k, i) of messages.wizardItems"
        :key="content.title"
        :title="content.title"
        :class="`sub-title-${i} mb-5 mt-10`"
      >
        <component v-if="content.subTitle" :is="'style'">
          .wizard-nav.wizard-nav-pills li:nth-child({{ i + 1 }})
          .stepTitle::after { content: "\A {{ content.subTitle }}"; }
        </component>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

const MESSAGES = {
  wizardItems: {
    stepOne: {
      title: "メールアドレス登録",
      subTitle: "案内メールを確認",
    },
    stepTwo: {
      title: "必要事項入力",
      subTitle: "企業情報を入力",
    },
    stepTree: {
      title: "登録完了",
      subTitle: "ログインして利用開始",
    },
  },
};

export default {
  name: "InvitesWizard",
  mixins: [],
  props: {
    messages: { type: Object, default: () => MESSAGES },
    wizardStartIndex: { type: Number, default: 0 },
    wizardStepShape: { type: String, default: "square" },
  },
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    nextTab() {
      this.$refs.formWizard.nextTab();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#enterprise-invites-wizard {
  .vue-form-wizard {
    max-width: 862px;
    min-height: 40px;
    height: fit-content;
    padding: 0;
    .wizard-header,
    .wizard-tab-content {
      display: none;
    }
    .wizard-navigation {
      .wizard-progress-with-circle {
        display: none;
      }
      .wizard-nav {
        &.wizard-nav-pills {
          column-gap: 78px;
          li {
            flex-basis: fit-content;
            flex-shrink: 0;
            flex-grow: 0;
            column-gap: 20px;
            .stepTitle {
              margin: 0;
              font-size: 16px;
              font-family: $aisea-font-family;
              font-weight: 600;
              text-align: start;
              &::after {
                white-space: pre;
                font-size: 12px;
                font-family: $aisea-font-family;
                font-weight: 400;
                color: $aisea-dark-gray;
              }
            }
            &:not(:first-child) > a {
              &::before {
                left: -46px;
                font-family: feather !important;
                content: "";
                color: $aisea-gray-black;
                position: absolute;
                font-variant: normal;
              }
            }
            a {
              flex-direction: row;
              flex-wrap: nowrap;
              column-gap: 20px;
              cursor: default;
              &.disabled {
                .wizard-icon-circle {
                  opacity: 0.3;
                }
              }
              .wizard-icon-circle {
                flex-shrink: 0;
                border-color: rgba($aisea-black, 1);
                width: 40px;
                height: 40px;
                border-radius: 7px;
                border: none;
                background-color: rgba($aisea-black, 0.05);
                color: #fff;
                background-color: rgba(var(--vs-primary), 1);
                &.checked {
                  border-color: rgba(var(--vs-primary), 1);
                  opacity: unset;
                  & + span {
                    color: rgba(var(--vs-primary), 1);
                  }
                }
                .wizard-icon-container {
                  border-radius: 7px;
                  font-family: $aisea-font-family;
                  font-size: 18px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
